import { Dayjs } from 'dayjs'
import { EnsMode } from '@enums/EnsMode'
import { proxy } from './proxy'

export const ens = {
  getEnsData: async (
    latitude: number,
    longitude: number,
    mode: EnsMode,
    date: Dayjs
  ) => {
    const formatedDate = date.format('YYYY-MM-DDTHH:mm:ss')
    const url = `https://charts.ecmwf.int/opencharts-api/v1/products/opencharts_meteogram/?epsgram=${mode}&lon=${longitude}&base_time=${formatedDate}Z&lat=${latitude}`
    const result = (await proxy.getOld(url)).data.data.link.href
    return result
  }
}
